<template>
  <div>
    <underlying-details-header :underlying="underlying" />

    <spot-price-chart
      v-if="underlying.spotData"
      :spot-data="underlying.spotData"
      :currency="underlying.data.currency"
    />

    <category-product-data
      v-if="$route.params.uid"
      category="underlying"
      :category-id="String($route.params.uid)"
      filter-key="underlying"
      :filter-value="String($route.params.uid)"
    />
  </div>
</template>

<script>
import CategoryProductData from './CategoryProductData.vue'
import SpotPriceChart from './SpotPriceChart.vue'
import UnderlyingDetailsHeader from './UnderlyingDetailsHeader.vue'

export default {
  components: {
    CategoryProductData,
    SpotPriceChart,
    UnderlyingDetailsHeader,
  },
  data() {
    return {
      underlying: {
        data: {
          name: '',
          currency: '',
          sections: [],
        },
        spotData: null,
        loading: false,
        error: false,
      },
    }
  },
  created() {
    this.getCategoryDataById()
  },
  methods: {
    getCategoryDataById() {
      if (!this.$route.params.uid) return

      this.underlying.loading = true
      this.underlying.error = false

      this.$http
        .get(`public.cfc?method=getCategoryDataById&category=underlying&id=${this.$route.params.uid}`)
        .then(response => {
          console.log('Category Data by ID for underlying:', response.data)

          // Extract underlying information from sections
          if (response.data.sections && response.data.sections.content) {
            const nameEntry = response.data.sections.content.find(item => item.section === 'Name')
            this.underlying.data.name = nameEntry ? nameEntry.entry : ''

            const currencyEntry = response.data.sections.content.find(item => item.section === 'Currency')
            this.underlying.data.currency = currencyEntry ? currencyEntry.entry : ''

            this.underlying.data.sections = response.data.sections.content
          }

          // Extract spot data for chart
          if (response.data.SPOTDATA) {
            this.underlying.spotData = response.data.SPOTDATA
          }
        })
        .catch(error => {
          console.error('Error fetching category data by ID:', error)
          this.underlying.error = error
        })
        .finally(() => {
          this.underlying.loading = false
        })
    },
  },
}
</script>
